/**
 * Endpoints de la conciergerie.
 *
 * Deux familles, servies par deux racines différentes et c'est volontaire :
 * `/api/conciergerie/*` est le back-office (l'équipe gère les dossiers),
 * `/api/portail/conciergerie/*` est l'espace formateur (le destinataire lit).
 * Les mêmes dossiers, deux droits qui n'ont rien à voir — les confondre sous
 * une seule racine ferait dépendre l'autorisation du contenu de la session
 * plutôt que du chemin.
 */

export const conciergerieEndpoints = {
  dossiers: () => '/api/conciergerie/dossiers',
  dossier: (id) => `/api/conciergerie/dossiers/${id}`,
  envois: (dossierId) => `/api/conciergerie/dossiers/${dossierId}/envois`,
  envoisParties: () => '/api/conciergerie/envois/parties',
  envoisTerminer: (dossierId) => `/api/conciergerie/dossiers/${dossierId}/envois/terminer`,
  envoisAbandonner: () => '/api/conciergerie/envois/abandonner',
  fichierTelechargement: (fichierId) => `/api/conciergerie/fichiers/${fichierId}/telechargement`,
  fichier: (fichierId) => `/api/conciergerie/fichiers/${fichierId}`,
  acces: (dossierId) => `/api/conciergerie/dossiers/${dossierId}/acces`,
  accesProlonger: (accesId) => `/api/conciergerie/acces/${accesId}/prolonger`,
  accesRetirer: (accesId) => `/api/conciergerie/acces/${accesId}`,
  destinataires: (search) => `/api/conciergerie/destinataires?search=${encodeURIComponent(search)}`,
}

export const conciergeriePortailEndpoints = {
  dossiers: () => '/api/portail/conciergerie',
  dossier: (id) => `/api/portail/conciergerie/${id}`,
  count: () => '/api/portail/conciergerie/count',
  fichierTelechargement: (fichierId) => `/api/portail/conciergerie/fichiers/${fichierId}/telechargement`,
}
